// contrato-400-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "A senha não pode ter só espaços": "La contraseña no puede tener solo espacios",
    "Adicione pelo menos um posto": "Agregue al menos una estación",
    "As senhas não conferem": "Las contraseñas no coinciden",
    "Campo não permitido": "Campo no permitido",
    "Campo obrigatório": "Campo obligatorio",
    "Data anterior à permitida": "Fecha anterior a la permitida",
    "Data inválida": "Fecha inválida",
    "Data posterior à permitida": "Fecha posterior a la permitida",
    "Deve ser maior que zero": "Debe ser mayor que cero",
    "Deve ser um número inteiro": "Debe ser un número entero",
    "E-mail inválido": "Correo electrónico inválido",
    "Endereço IP inválido": "Dirección IP inválida",
    "Endereço de requisição inválido": "Dirección de solicitud inválida",
    "Endereço inválido": "Dirección inválida",
    "Escolha pelo menos um público": "Elija al menos un público",
    "Formato inválido": "Formato inválido",
    "Identificador inválido": "Identificador inválido",
    "Informe a quantidade (inteiro, pelo menos 1)": "Informe la cantidad (entero, al menos 1)",
    "Informe ao menos um item": "Informe al menos un elemento",
    "Informe o id numérico": "Informe el id numérico",
    "Informe só o host ou IP, sem http:// e sem porta": "Informe solo el host o la IP, sin http:// y sin puerto",
    "Itens demais": "Demasiados elementos",
    "Itens repetidos": "Elementos repetidos",
    "Lista inválida": "Lista inválida",
    "Muito curto": "Demasiado corto",
    "Muito longo": "Demasiado largo",
    "Não pode ficar vazio": "No puede quedar vacío",
    "Número inválido": "Número inválido",
    "O abastecimento escolhido não está mais na lista. Escolha de novo.": "El abastecimiento elegido ya no está en la lista. Elija de nuevo.",
    "O limite máximo é de 10.000.000 de números da sorte": "El límite máximo es de 10.000.000 de números de la suerte",
    "Preencha todas as credenciais ou deixe todas em branco": "Complete todas las credenciales o deje todas en blanco",
    "Revise: %{campos}": "Revise: %{campos}",
    "Selecione os postos e ao menos um combustível para atualizar.": "Seleccione las estaciones y al menos un combustible para actualizar.",
    "Tamanho inválido": "Longitud inválida",
    "Texto inválido": "Texto inválido",
    "Valor abaixo do permitido": "Valor por debajo del permitido",
    "Valor acima do permitido": "Valor por encima del permitido",
    "Valor inválido": "Valor inválido",
    "Valor inválido (sim ou não)": "Valor inválido (sí o no)",
    "Valor não permitido": "Valor no permitido",
};

export default catalogo;
